import { authActionTypes } from "../constants/authActionTypes";

export const addUID = (val) => {
  return { type: authActionTypes.ADD_UID, payload: val };
};
export const addUser = (val) => {
  return { type: authActionTypes.ADD_USER, payload: val };
};
export const setNewUser = (val) => {
  return { type: authActionTypes.SET_NEW_USER, payload: val };
};
export const logout = () => {
  return { type: authActionTypes.LOGOUT };
};
